import React from 'react'
import styled from 'styled-components'
import Card from '@jarvis.oddle/core/components/Card'
import Flex from '@jarvis.oddle/core/components/Flex'
import { RadioDot } from '@jarvis.oddle/core/components/Radio'
import IconBuilding from '@jarvis.oddle/core/components/Icons/IconBuilding'
import IconHouse from '@jarvis.oddle/core/components/Icons/IconHouse'
import { H4 } from '@jarvis.oddle/core/components/Typo'
import { margin, marginSizes, borderRadiusSizes, colors, colorConstants } from '@jarvis.oddle/core/theme/default'

const Container = styled(Card).attrs(() => ({
  borderRadius: borderRadiusSizes.medium,
  justifyContent: 'space-between',
  alignItems: 'center'
}))`
  display: flex;
  min-height: 60px;
  ${props => props.checked ? `
    background-color: ${colorConstants.white};
  ` : `
    background-color: ${colorConstants.lightestGray};
  `}
  margin-top: ${margin[marginSizes.small]};
  margin-bottom: ${margin[marginSizes.medium]};

  &&& {
    ${props => props.checked ? `
      border-color: ${colorConstants.matteBlack};
    ` : `
      border-color: ${colorConstants.lightGray};
    `}
  }

  &:hover {
    opacity: 0.8;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    pointer-events: auto;
  }
`

const StyledRadioDot = styled(RadioDot)`
  background-color: ${colorConstants.white};
  ${props => props.checked ? `border-color: ${colorConstants.matteBlack};` : `border-color: ${colorConstants.lightGray};`}
`

const IconContainer = styled(Flex).attrs(() => ({
  justifyContent: 'center',
  alignItems: 'center'
}))`
  flex: 0 0 60px;
`

const PaymentNameContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  justifyContent: 'flex-start',
  alignItems: 'center'
}))`
  flex: 0 1 auto;
  margin-right: ${margin[marginSizes.medium]};
`

const PaymentIconContainer = styled(Flex).attrs(() => ({
  flexDirection: 'row',
  justifyContent: 'flex-end',
  alignItems: 'center'
}))`
  flex: 1 0 auto;
`

const AddressTypeOption = ({
  addressType,
  addressTypeName,
  selected,
  onClick
}: {
  addressType: string
  addressTypeName: string
  selected: boolean
  onClick: (addressType) => void
}): JSX.Element => {
  const getIcon = (addressType) => {
    switch (addressType) {
      case 'building':
        return <IconBuilding iconSize='large' fill={colors.text} />
      case 'house':
        return <IconHouse iconSize='large' fill={colors.text} />
      default:
        return null
    }
  }

  return (
    <Container role='radio' onClick={() => onClick(addressType)} checked={selected}>
      <React.Fragment>
        <PaymentNameContainer>
          <StyledRadioDot checked={selected} />
          <H4 normalised textAlign='left' color={colors.text} marginLeft={marginSizes.small}>{addressTypeName}</H4>
        </PaymentNameContainer>
        <PaymentIconContainer>
          <IconContainer>
            {getIcon(addressType)}
          </IconContainer>
        </PaymentIconContainer>
      </React.Fragment>
    </Container>
  )
}

export default AddressTypeOption
